<template>
  <sPopover
    :disabled="!usePoper || disabled"
    placement="bottom-start"
    trigger="hover">
    <div
      slot="reference"
      class="step-number"
      :class="classMame || ''"
      style="cursor: default; text-align: left;">
      {{ $t('Catalog.Step') }} {{ step_num }} / {{ all_steps || all_steps_num }}
    </div>
    <div
      v-if="usePoper">
      <MenuItem
        v-for="(stepItem, stepIndex) in info.steps"
        :key="`step-${stepIndex}`"
        :class="{'is-active-menu-item': (stepIndex + 1) === (step_num)}"
        :data-qa="`step-${stepIndex}`"
        :disabled="(stepIndex + 1) === (step_num) || disabled"
        @click="changeStep(stepIndex+1)">
        <div slot="content">
          <span>{{ stepIndex+1 }} </span>.
          <span>{{ $t(`Tenders.${stepItem}`) | firstUpperCase }}</span>
        </div>
      </MenuItem>
    </div>
  </sPopover>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'

export default {
  name: 'stepNumber',
  props: {
    step: String,
    disabled: {
      type: Boolean
    },
    all_steps: String,
    classMame: String
  },
  methods: {
    changeStep(stepNumber) {
      this.$store.commit('setNewTenderInfo', { ...this.info, step: stepNumber } )
      if (this.$route.query.step) {
        this.$router.replace({
          name: this.$route.name,
          query: {...this.$route.query, step: stepNumber}})
      }
    }
  },
  computed: {
    usePoper() {
      return !!this.info?.steps?.length
    },
    info() {
      return this.$store.getters['getNewTenderInfo']
    },
    step_num() {
      return this.step || this.info.step || 1
    },
    all_steps_num() {
      return this.info?.steps?.length
    }
  },
  filters: {
    firstUpperCase(val) {
      return val[0].toUpperCase() + val.slice(1)
    }
  },
  components: {
    MenuItem
  }
}
</script>
<style scoped>
.is-active-menu-item {
  background: var(--color-main-green);
}
.step-number {
  white-space: normal;
  font-size: 11px;
  line-height: 14px;
  letter-spacing: 0.02em;
  color: var(--v-secondary__green_not_active-base);
  text-transform: uppercase;
  margin-bottom: 8px;
  padding-left: 0px;
}
</style>
